module.exports = __webpack_public_path__ + "img/defensive_kodo_farm_small.afad4ba8.png";